import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import { localStorageKeys, orderStatusMapping } from '../../utils/constants';
import { jwtDecode } from 'jwt-decode';
import { OrderDataProviderContext } from '../../context-api/data-provider/OrderDataProvider';
import PrintReceipt from '../../composed/printReceipt/PrintReceipt';
import RunCircleIcon from '@mui/icons-material/RunCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CookingTimer from '../../composed/LiveTimer/CookingTimer';
import TextTransformation from '../../utils/textTransformation';
import { isMobile, isIpad, isDesktop } from '../../utils/ScreenSizeHelper';
import { getFriendlyDateLabel } from '../../utils/dateFormat';
import NoOrderFound from './NoOrderFound';

const ScheduledOrder = (props) => {
  const {
    isLoggedIn,
    selectedMenuTab,
    setSelectedMenuTab,
    setisLoggedIn,
    newPendingOrder,
    setNewPendingOrder,
    preparingOrder,
    setPreparingOrder,
    scheduledOrder,
    setScheduledOrder,
    openOrderAlert,
    setOpenOrderAlert,
    allOrders,
    setAllOrders,
  } = useContext(GlobalStateDataContext);

  const { onGetOrders, currentDate } = useContext(OrderDataProviderContext);

  const [clickedScheduledOrder, setClickedScheduledOrder] = useState({});

  const { REFRESH_TOKEN, TOKEN } = localStorageKeys;
  const hasTokens = localStorage.getItem(TOKEN);

  const [startNo, endNo] = (clickedScheduledOrder?.order_no || '').split('-');
  const isMealOrder = endNo?.includes('MEAL');

  const StyleTotalBlock = {
    fontFamily: 'Inter Medium',
    fontSize: '15px',
  };

  const StyleNumberBlock = {
    fontFamily: 'Inter Medium',
    fontSize: '15px',
  };

  const promoTypeLabel = (discount_type, discountedAmount) => {
    // You have to create paths on app.js before coming here to add tan name
    switch (discount_type) {
      case 'percentage':
        return `${discountedAmount}% off`;
      case 'plates':
        return `${discountedAmount} Free meal`;
      case 'amount_off':
        return `- $${discountedAmount} off`;
      case 'product':
        return `- $${discountedAmount} off`;
      case 'free_delivery':
        return `- $${discountedAmount} Delivery off`;
      case 'percentage_delivery':
        return `${discountedAmount}% Delivery off`;
      case 'free':
        return `Free order`;
    }
  };

  let KitchenName = null;
  if (hasTokens) {
    const decodedToken = jwtDecode(hasTokens);
    const { email, kitchenName } = decodedToken || null;
    KitchenName = kitchenName;
  }

  const FetchOrdersDirect = async () => {
    const nextDate = moment().add(1, 'days').format('MM/DD/YYYY');
    setClickedScheduledOrder({});
    setScheduledOrder([]);
    const payload = {
      date: nextDate,
      kitchen_name: KitchenName,
      order_history: false,
    };
    const OrderData = await onGetOrders(payload);

    if (OrderData?.joinedOrders?.length > 0) {
      OrderData?.joinedOrders?.forEach((order) => {
        const OrderInformation = {
          ...order.payAsYouGoOrder,
          order_no: order.payAsYouGoOrder?.joined_order_no
            ? order.payAsYouGoOrder?.joined_order_no
            : order.payAsYouGoOrder?.order_no,
          item_names: [
            ...(order.payAsYouGoOrder?.item_names || []),
            ...(order.mealOrder?.item_name || []),
          ],
        };

        setScheduledOrder((prev) => [...prev, OrderInformation]);
      });
    }

    if (OrderData?.payAsYouGoOrders?.length > 0) {
      OrderData?.payAsYouGoOrders?.forEach((order) => {
        setScheduledOrder((prev) => [...prev, order]);
      });
    }

    if (OrderData?.mealOrders?.length > 0) {
      OrderData?.mealOrders?.forEach((order) => {
        setScheduledOrder((prev) => [...prev, order]);
      });
    }

    if (OrderData?.PromotionalOrders?.length > 0) {
      OrderData?.PromotionalOrders?.forEach((order) => {
        setScheduledOrder((prev) => [...prev, order]);
      });
    }
  };

  const checkOrderTime = (arg) => {
    const [startTime] = arg.delivery_time_slot.split(' - ');
    const deliveryDateTimeStr = `${arg.delivery_date} ${startTime.trim()}`;

    const deliveryStartTime = new Date(deliveryDateTimeStr);
    const now = new Date();
    const diffInMs = deliveryStartTime - now;
    const diffInHours = diffInMs / (1000 * 60 * 60);

    if (diffInHours <= 3) {
      setOpenOrderAlert(true);
      setClickedScheduledOrder({});
      setScheduledOrder((prevOrders) => {
        const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);
        return [...filteredOrders];
      });

      setNewPendingOrder((prevOrders) => {
        const isDuplicate = prevOrders.some((order) => order.order_no === arg.order_no);
        if (isDuplicate) return prevOrders; // Don't add duplicate

        return [...prevOrders, arg]; // Add only if not a duplicate
      });

      // setNewPendingOrder(prevItems => [...prevItems, arg])
    }
  };

  useEffect(() => {
    FetchOrdersDirect();
  }, []);

  useEffect(() => {
    let Interval = null;

    if (scheduledOrder?.length > 0) {
      // if (Interval) {
      //     clearTimeout(Interval)
      // }

      console.log('-----Run every 10 min schedule order');

      Interval = setTimeout(() => {
        scheduledOrder?.forEach((arg) => {
          checkOrderTime(arg);
        });
      }, 60000); // 10 minutes = 600000 ms
    }

    return () => {
      if (Interval) {
        clearTimeout(Interval);
      }
    };
  }, [JSON.stringify(scheduledOrder)]);

  if (scheduledOrder?.length <= 0 && selectedMenuTab === 'scheduled') {
    return <NoOrderFound />;
  }

  if (selectedMenuTab === 'scheduled') {
    return (
      <div style={{ display: 'flex', height: '96vh' }}>
        <div
          style={{
            width: '32%',
            borderRight: '1px solid #ccd0d5',
          }}
        >
          {scheduledOrder.map((item) => {
            const [startNo, endNo] = item.order_no.split('-');
            const totalItems = item?.item_names?.length;
            const mealTotalItems = item?.item_name?.length;

            const [part1, part2Raw] = getFriendlyDateLabel(item.delivery_date)?.split(',');
            const part2 = part2Raw.trim(); // Remove leading space

            return (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  // alignItems: 'center',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: 'auto',
                  borderRadius: '3px',
                  margin: '4px',
                  padding: '10px 10px 20px 10px',
                  backgroundColor: '#FFE99A',
                  color: '#1E3E62',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setClickedScheduledOrder(item);
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={{
                      fontSize: '16px',
                      fontFamily: 'Inter Bold',
                      textTransform: 'capitalize',
                      letterSpacing: '0.5px',
                      marginBottom: '10px',
                    }}
                  >
                    {' '}
                    {item.cust_firstName}
                  </div>

                  <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}>
                    {' '}
                    {`# ${endNo}`}
                  </div>
                  <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}>
                    {' '}
                    {totalItems || mealTotalItems}{' '}
                    {totalItems === 1 || mealTotalItems === 1 ? 'item' : 'items'}{' '}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      border: '2px solid #1E3E62',
                      backgroundColor: '#1E3E62',
                      fontSize: '14px',
                      borderRadius: '3px',
                      padding: '2px 5px 2px 5px',
                      color: 'white',
                      marginTop: '10px',
                      textTransform: 'uppercase',
                    }}
                  >
                    {orderStatusMapping[item.internal_order_status]}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '1px solidrgb(81, 241, 153)',
                    height: '80px',
                    width: '100px',
                    borderRadius: '3px',
                    backgroundColor: '#81E7AF',
                  }}
                >
                  <div style={{ fontSize: '14px', fontFamily: 'Inter Bold' }}> {part1}</div>
                  <div style={{ fontSize: '14px', fontFamily: 'Inter Medium' }}> {part2}</div>
                </div>
              </div>
            );
          })}
        </div>

        {Object.keys(clickedScheduledOrder).length > 0 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '65%',
              backgroundColor: 'white',
              borderLeft: '1px solid #ccd0d5',
              padding: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div
                  style={{
                    textTransform: 'capitalize',
                    color: 'rgb(24, 20, 54)',
                    fontSize: '18px',
                    fontFamily: 'Inter Bold',
                  }}
                >
                  {clickedScheduledOrder?.cust_firstName}
                </div>
                <div style={{ fontSize: '14px' }}>{endNo} </div>

                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                  <div style={{ fontSize: '13px', fontFamily: 'Inter Regular' }}>Delivery slot</div>
                  <div style={{ fontSize: '14px', fontFamily: 'Inter Bold' }}>
                    {' '}
                    {clickedScheduledOrder?.delivery_time_slot}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ fontFamily: 'Inter Regular', fontSize: '14px' }}> Date</div>
                <div style={{ fontFamily: 'Inter Bold', fontSize: '14px', color: 'green' }}>
                  {getFriendlyDateLabel(clickedScheduledOrder?.delivery_date)}
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ margin: '5px 10px 5px 5px' }}>
                  {' '}
                  <PrintReceipt data={clickedScheduledOrder} />
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  {clickedScheduledOrder?.delivery_type === 'home delivery' && (
                    <a style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                      <LocalShippingIcon
                        sx={{ color: '#181436', fontSize: '25px', margin: '0px 5px 0px 0px' }}
                      />{' '}
                      <a style={{ fontSize: '15px' }}>Home Delivery</a>
                    </a>
                  )}

                  {clickedScheduledOrder?.delivery_type === 'pickup' && (
                    <a style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                      <RunCircleIcon
                        sx={{ color: '#181436', fontSize: '25px', margin: '0px 5px 0px 0px' }}
                      />{' '}
                      <a style={{ fontSize: '15px' }}>Pickup</a>
                    </a>
                  )}
                </div>
              </div>
            </div>

            {isMealOrder === false && Object.keys(clickedScheduledOrder).length > 0 && (
              <div style={{ marginTop: '20px', width: '80%', marginLeft: '30px' }}>
                <div
                  style={{
                    marginLeft: '10px',
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    color: '#929293',
                  }}
                >
                  Item{clickedScheduledOrder?.item_names?.length > 1 ? 's' : ''}
                </div>
                <div style={{ margin: '10px 10px 10px 15px', alignContent: 'center' }}>
                  {clickedScheduledOrder?.item_names?.map((item, i) => {
                    let price = 'Meal item';
                    let isMealItem = false;

                    if (item?.price) {
                      price = item.qty * item.price;
                    }

                    {
                      /* if (item?.mealItemPrice) {
                                             price = item?.mealItemPrice
         
                                         } */
                    }

                    if (item?.product_category) {
                      isMealItem = true;
                    }

                    const displayPrice = price === 'Meal item' ? 'Meal item' : `$${price}`;

                    if (
                      item?.promotion === 'buy_one_get_one_free' &&
                      price !== 'Meal item' &&
                      item.qty > 1
                    ) {
                      price = (item.qty - Math.floor(item.qty / 2)) * item.price;
                    } else if (
                      item?.promotion === 'buy_two_get_one_free' &&
                      price !== 'Meal item' &&
                      item.qty > 2
                    ) {
                      price = (item.qty - Math.floor(item.qty / 3)) * item.price;
                    } else if (
                      item?.promotion === 'buy_one_get_half_price' &&
                      price !== 'Meal item' &&
                      item.qty > 1
                    ) {
                      price =
                        (item.qty - Math.floor(item.qty / 2) + Math.floor(item.qty / 2) / 2) *
                        item.price;
                    }

                    return (
                      <div
                        style={{ alignContent: 'center', marginBottom: '10px' }}
                        key={`${item}_${i}`}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignText: 'center',
                            alignContent: 'center',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              fontFamily: 'Roboto Medium',
                              fontSize: '11px',
                              justifyContent: 'center',
                              backgroundColor: '#e8e7e9',
                              alignItems: 'center',
                              border: '1px solid #c7c7c7',
                              borderRadius: '3px',
                              height: '18px',
                              width: '22px',
                              margin: '0px 10px 5px 0px',
                            }}
                          >
                            {item.qty}
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div
                              style={{
                                fontFamily: 'Roboto Medium',
                                fontSize: '16px',
                                color: '#181436',
                                textTransform: 'capitalize',
                                letterSpacing: '0.5px',
                              }}
                            >
                              {item.item}
                            </div>
                            {item?.promotion && (
                              <div
                                style={{
                                  fontFamily: 'Roboto Regular',
                                  fontSize: '13px',
                                  color: '#BABABA',
                                  marginTop: '2px',
                                  marginBottom: '5px',
                                }}
                              >
                                Applied -{' '}
                                <a
                                  style={{
                                    fontFamily: 'Roboto Medium',
                                    fontSize: '13px',
                                    color: 'rgb(69, 165, 23)',
                                  }}
                                >
                                  {' '}
                                  {TextTransformation(item?.promotion)}
                                </a>
                              </div>
                            )}
                            {isMealItem && (
                              <div
                                style={{
                                  fontSize: '12px',
                                  fontFamily: 'Inter Regular',
                                  color: 'lightgray',
                                }}
                              >
                                {' '}
                                Meal item
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              flex: 1,
                              textAlign: 'right',
                              fontFamily: 'Roboto Medium',
                              fontSize: '14px',
                              color: '#181436',
                            }}
                          >
                            {' '}
                            {displayPrice}
                          </div>
                        </div>
                        {item?.extra_toppings?.map((t, j) => (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              margin: '0px 0px 0px 35px',
                            }}
                            key={t.topping_name}
                          >
                            <div
                              style={{
                                fontFamily: 'Roboto Regular',
                                fontSize: '13px',
                                color: '#181436',
                                marginRight: '30px',
                                textTransform: 'capitalize',
                                letterSpacing: '0.5px',
                              }}
                            >{`${t.topping_name} (${t.topping_qty})`}</div>
                            <div
                              style={{
                                fontFamily: 'Roboto Regular',
                                fontSize: '13px',
                                color: '#181436',
                                marginRight: '10px',
                              }}
                            >
                              ${(t.topping_qty * t.price).toFixed(2)}
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {isMealOrder === true && Object.keys(clickedScheduledOrder).length > 0 && (
              <div style={{ marginTop: '20px', width: '80%', marginLeft: '30px' }}>
                <div
                  style={{
                    marginLeft: '10px',
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    color: '#929293',
                  }}
                >
                  Item{clickedScheduledOrder?.item_names?.length > 1 ? 's' : ''}
                </div>
                <div style={{ margin: '10px 10px 10px 15px', alignContent: 'center' }}>
                  {clickedScheduledOrder?.item_name?.map((item, i) => {
                    let price = 'Meal item';
                    const displayPrice = price === 'Meal item' ? 'Meal item' : `$${price}`;

                    return (
                      <div
                        style={{ alignContent: 'center', marginBottom: '10px' }}
                        key={`${item}_${i}`}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignText: 'center',
                            alignContent: 'center',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              fontFamily: 'Roboto Medium',
                              fontSize: '11px',
                              justifyContent: 'center',
                              backgroundColor: '#e8e7e9',
                              alignItems: 'center',
                              border: '1px solid #c7c7c7',
                              borderRadius: '3px',
                              height: '18px',
                              width: '22px',
                              margin: '0px 10px 5px 0px',
                            }}
                          >
                            {item.qty}
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div
                              style={{
                                fontFamily: 'Roboto Medium',
                                fontSize: '16px',
                                color: '#181436',
                                textTransform: 'capitalize',
                              }}
                            >
                              {item.item}
                            </div>
                            {item?.promotion && (
                              <div
                                style={{
                                  fontFamily: 'Roboto Regular',
                                  fontSize: '11px',
                                  color: '#BABABA',
                                  marginTop: '2px',
                                  marginBottom: '5px',
                                }}
                              >
                                Applied -{' '}
                                <a
                                  style={{
                                    fontFamily: 'Roboto Medium',
                                    fontSize: '11px',
                                    color: 'rgb(69, 165, 23)',
                                  }}
                                >
                                  {' '}
                                  {TextTransformation(item?.promotion)}
                                </a>
                              </div>
                            )}

                            {item?.product_category && (
                              <div
                                style={{
                                  fontSize: '12px',
                                  fontFamily: 'Inter Regular',
                                  color: 'lightgray',
                                }}
                              >
                                Meal item
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              flex: 1,
                              textAlign: 'right',
                              fontFamily: 'Roboto Medium',
                              fontSize: '14px',
                              color: '#181436',
                            }}
                          >
                            {' '}
                            {price}
                          </div>
                        </div>
                        {item?.extra_toppings?.map((t, j) => (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              margin: '0px 0px 0px 35px',
                            }}
                            key={t.topping_name}
                          >
                            <div
                              style={{
                                fontFamily: 'Roboto Regular',
                                fontSize: '13px',
                                color: '#181436',
                                marginRight: '30px',
                                textTransform: 'capitalize',
                              }}
                            >{`${t.topping_name} (${t.topping_qty})`}</div>
                            <div
                              style={{
                                fontFamily: 'Roboto Regular',
                                fontSize: '13px',
                                color: '#181436',
                                marginRight: '10px',
                              }}
                            >
                              ${(t.topping_qty * t.price).toFixed(2)}
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div
              style={{
                margin: isIpad ? '10px 0px 20px 38%' : '10px 0px 20px 60%',
                width: isIpad ? '45%' : '22%',
              }}
            >
              <div
                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
              >
                <div style={StyleTotalBlock}> Sub total</div>
                <div style={StyleNumberBlock}>
                  {' '}
                  ${(clickedScheduledOrder?.sub_total || 0.0)?.toFixed(2)}
                </div>
              </div>
              <div
                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
              >
                <div style={StyleTotalBlock}> Delivery Fee</div>
                <div style={StyleNumberBlock}>
                  {' '}
                  $
                  {clickedScheduledOrder?.delivery_price?.toFixed(2) ||
                    clickedScheduledOrder?.deliverySubscription_fee?.toFixed(2)}
                </div>
              </div>

              {clickedScheduledOrder?.discount_coupon_no && (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={StyleTotalBlock}>Discount</div>
                    <div style={{ ...StyleNumberBlock, color: 'green' }}>
                      {' '}
                      {promoTypeLabel(
                        clickedScheduledOrder?.discount_type,
                        clickedScheduledOrder?.discountedAmount
                      )}
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={StyleTotalBlock}> Discount code</div>
                    <div style={{ ...StyleNumberBlock, textTransform: 'uppercase' }}>
                      {' '}
                      {clickedScheduledOrder?.discount_coupon_no}
                    </div>
                  </div>
                </div>
              )}

              <div
                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
              >
                <div style={StyleTotalBlock}>Tax & other fee</div>
                <div style={StyleNumberBlock}>
                  {' '}
                  $
                  {(
                    clickedScheduledOrder?.tax_plus_serviceFees || clickedScheduledOrder?.tax
                  )?.toFixed(2)}
                </div>
              </div>
              <div
                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
              >
                <div style={StyleTotalBlock}>Tip</div>
                <div style={StyleNumberBlock}> ${clickedScheduledOrder?.tip?.toFixed(2)}</div>
              </div>

              {clickedScheduledOrder?.promoOrderAmountAdded_In_Total_charged !== 0 && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: '10px',
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ ...StyleTotalBlock, fontSize: '13px' }}>Complimentary Item</div>
                    <div style={{ fontSize: '12px', color: 'gray' }}> Packaging & Delivery Fee</div>
                    <div style={{ fontSize: '12px', color: 'green' }}> Arriving Tomorrow</div>
                  </div>

                  <div style={StyleNumberBlock}>
                    {' '}
                    ${clickedScheduledOrder?.promoOrderAmountAdded_In_Total_charged?.toFixed(2)}
                  </div>
                </div>
              )}

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginTop: '10px',
                }}
              >
                <div style={{ ...StyleTotalBlock, fontFamily: 'Inter Bold' }}>Total</div>
                <div style={{ ...StyleNumberBlock, fontFamily: 'Inter Bold' }}>
                  {' '}
                  ${clickedScheduledOrder?.total_charged?.toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default ScheduledOrder;
